import React from "react";
import "./TeamSection.css";
import { FaLinkedinIn, FaMailBulk } from "react-icons/fa";
import { useTranslation } from "react-i18next";

import photo1 from "./assets/greg.png";
import photo2 from "./assets/alycia.jpg";
import photo3 from "./assets/paul.jpg";

function TeamSection() {
  const { t } = useTranslation();

  const teamMembers = [
    {
      id: 1,
      name: "Gregory MONFORT",
      role: "CEO",
      desc: t("team_section.greg_desc"),
      photo: photo1,
      linkedin: "https://www.linkedin.com/in/gr%C3%A9gory-monfort-1267402b/",
      email: "gm.acegood@gmail.com",
    },
    {
      id: 2,
      name: "Alicya MENDES",
      role: "COO",
      desc: t("team_section.alicya_desc"),
      photo: photo2,
      linkedin: "https://www.linkedin.com/in/alicya-mendes/",
      email: "am.acegood@gmail.com",
    },
    {
      id: 3,
      name: "Paul BROUSSOULOUX",
      role: "CTO / CPO",
      desc: t("team_section.paul_desc"),
      photo: photo3,
      linkedin: "https://www.linkedin.com/in/paul-broussouloux-5ab904173/",
      email: "pb.acegood@gmail.com",
    },
  ];

  return (
    <section className="team-section">
      <div className="team-header">
        <p className="subtitle">
          {t("team_section.title")}{" "}
          <span className="gradient-text">{t("team_section.title_span")}</span>
        </p>
        <p className="team-subtitle">{t("team_section.subtitle")}</p>
      </div>

      <div className="team-grid">
        {teamMembers.map((member) => (
          <div key={member.id} className="team-card">
            <div className="img-wrapper">
              <img src={member.photo} alt={member.name} />

              {/* --- 2. LE MASQUE AVEC LES ICÔNES --- */}
              <div className="social-overlay">
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noreferrer"
                  className="icon-btn"
                >
                  <FaLinkedinIn />
                </a>
                <a href={`mailto:${member.email}`} className="icon-btn">
                  <FaMailBulk />
                </a>
              </div>
            </div>

            <div className="team-info">
              <h3>{member.name}</h3>
              <p className="role">
                <span className="gradient-text">{member.role}</span>
              </p>
              <p>{member.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default TeamSection;
